import { render, staticRenderFns } from "./SpectrumDiagram.vue?vue&type=template&id=95ef5746&scoped=true&"
import script from "./SpectrumDiagram.vue?vue&type=script&lang=ts&"
export * from "./SpectrumDiagram.vue?vue&type=script&lang=ts&"
import style0 from "./SpectrumDiagram.vue?vue&type=style&index=0&id=95ef5746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef5746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
